import { Typography } from '@sravni/react-design-system';

import type { CellContext } from '@tanstack/table-core';

import type { RatingItem } from '../../../types/rating';

import styles from './columns.module.scss';

export const makeCommonColumn = <T extends RatingItem>(info: CellContext<T, any>) => (
  <Typography.Text size={14} className={styles.commonColumn}>
    {info.getValue() ?? '—'}
  </Typography.Text>
);
